export function geoJSONManager(geoJSON: any | undefined, lat: number, lon: number): any {
  if (!geoJSON) {
    geoJSON = {
      type: "FeatureCollection",
      features: [
        {
          type: "Feature",
          properties: {
            "stroke": "#555555",
            "stroke-width": 3,
            "stroke-opacity": 0.8
          },
          geometry: {
            type: "LineString",
            coordinates: []
          }
        }
      ]
    };
  }
  geoJSON.features[0].geometry.coordinates.push([lon, lat]);

  // Determine colors
  const GREEN = "#10b981"; // first pointer
  const AMBER = "#f59e0b"; // in between pointer
  const RED = "#ef4444";   // last pointer

  // Number of existing point features (exclude the first feature which is the line)
  const existingPointCount = geoJSON.features.length - 1;

  // If there is a previous last point (and it's not the first point), set it to amber
  const prevLastIndex = geoJSON.features.length - 1;
  if (existingPointCount >= 2 && prevLastIndex >= 2) {
    geoJSON.features[prevLastIndex].properties["marker-color"] = AMBER;
  }

  let markerColor = RED;
  if (existingPointCount === 0) {
    markerColor = GREEN;
  }

  geoJSON.features.push({
    type: "Feature",
    properties: {
      "marker-size": "small",
      "marker-color": markerColor
    },
    geometry: {
      type: "Point",
      coordinates: [lon, lat]
    }
  });

  return geoJSON;
}
